export { default as useMaterialsBrandsFilter } from './useMaterialsBrandsFilter';
